const defaultParameters: any = {
    paymentAmount: {
        filterName: "paymentAmount",
        label: 'Payment',
        filterType: 'range',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    internetPrice: {
        filterName: "internetPrice",
        label: 'Price',
        filterType: 'range',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    miles: {
        filterName: "miles",
        label: 'Miles',
        filterType: 'range',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    year: {
        filterName: "year",
        label: 'Year',
        filterType: 'range',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    style: {
        filterName: "style",
        label: 'Style',
        filterType: 'array',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    make: {
        filterName: "make",
        label: 'Make',
        filterType: 'array',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    model: {
        filterName: "model",
        label: 'Model',
        filterType: 'array',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    transmission: {
        filterName: "transmission",
        label: 'Transmission',
        filterType: 'array',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
    lotName: {
        filterName: "lotName",
        label: 'Lot',
        filterType: 'array',
        isFiltered: false,
        orderFiltered: 0,
        values: [],
    },
};

export default defaultParameters;